import React from "react"
import InStock from "../../icons/InStock.svg"
import OutOfStock from "../../icons/OutOfStock.svg"
import LowStock from "../../icons/LowStock.svg"

const ErpBadges = ({ product, availableForSale }) => {
  return (
    <div className="my-3">
      {availableForSale ? (
        <div className=" flex flex-row">
          <InStock />
          <h6 className="mx-[6px] text-darkGrey">In Stock</h6>
        </div>
      ) : product?.totalInventory <= 3 && product?.totalInventory > 0 ? (
        <div className="flex flex-row">
          <LowStock /> <h6 className="mx-[6px] text-darkGrey">Low Stock</h6>{" "}
        </div>
      ) : (
        <div className="flex flex-row">
          <OutOfStock />
          <h6 className="mx-[6px] text-darkGrey">Out of Stock</h6>
        </div>
      )}
    </div>
  )
}

export default ErpBadges
